<form [formGroup]="shiftForm" class="pb-2">
  <div *ngIf="checkoutShiftloaded" class="row g-3" [formGroup]="shiftForm">
    <div class="col-lg-4">
      <div class="card mb-3">
        <div class="card-body p-3">
          <div class="row g-3">
            <div class="col-12">
              <h5 (click)="schedule()" class="cursor-pointer mb-2">
                <fa-icon [icon]="fa.faChevronCircleLeft" style="font-size: 1.7rem; position: relative; top: 3px; margin-inline-end: 0.3rem;"></fa-icon>
                {{ checkoutShifts.shifts[0].assignment | translateField: 'name' }}
              </h5>
              <div class="row align-items-center">
                <div class="col-auto pe-0 me-0">
                  <img [src]="'/api/customer/employees/' + checkoutShifts.shifts[0].employee.id + '/picture' | authImg | async"
                       style="border-radius: 50%; width: 4rem;" class="me-0">
                </div>
                <div class="col">
                  <h5 class="mb-0">{{ checkoutShifts.shifts[0].employee.first_name }}</h5>
                  {{ checkoutShifts.shifts[0].employee | translateField: 'description' }}
                </div>
              </div>
            </div>
            <div class="col-12">
              <h5 i18n>Location</h5>
              <span *ngIf="checkoutShifts.shifts[0].customer.type != 'individual'">{{ checkoutShifts.shifts[0].customer.name
                }}&nbsp;</span>{{
              checkoutShifts.shifts[0].customer.street_address }} {{ checkoutShifts.shifts[0].customer.city }}
            </div>
            <div class="col-12">
              <h5 i18n>Your order</h5>
              <p *ngIf="orderProducts.length == 0" i18n>Your order is empty. Select services by clicking the
                "Order".
              </p>
              <div *ngIf="orderProducts.length > 0" class="row mb-0">
                <div *ngFor="let product of orderProducts; let i = index" class="col-12 mb-3 d-flex align-items-center">
                  <img [alt]="product.product | translateField: 'name'" [src]="product.product.picture" class="me-2"
                    style="width: 4rem; height: 4rem; border-radius: 50%; object-fit: cover;">
                  <div class="flex-grow-1">
                    <div>{{ product.number | number: '1.0-2' }} x <strong>{{ product.product | translateField:
                        'name'
                        }}</strong> (<span style="text-transform: lowercase;">{{ product.product.unit | i18nSelect:
                        productUnits
                        }}</span>)</div>
                    <div *ngIf="product.notes" class="text-muted">{{ product.notes }}</div>
                  </div>
                  <div class="ms-2 text-nowrap">
                    <button (click)="editProduct(i)" class="btn btn-primary me-1">
                      <fa-icon [icon]="fa.faEdit" style="color: #fff; position: relative; top: -1px;"></fa-icon>
                    </button>
                    <button (click)="deleteProduct(i)" class="btn btn-danger">
                      <fa-icon [icon]="fa.faTrash" style="color: #fff; position: relative; top: -1px;"></fa-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12" class="mt-0">
              <h5 i18n>Notes to partner</h5>
              <textarea class="form-control" rows="5" formControlName="notes"></textarea>
            </div>
            <div class="col-12">
              <button (click)="pictureTag.click()" type="button" class="btn btn-primary w-100">
                <fa-icon [icon]="fa.faCamera" style="color: #fff;"></fa-icon>&nbsp;
                <span i18n>Take a picture</span>
              </button>
              <input #pictureTag (change)="pictureAdd($event)" type="file" id="picture-tag" accept="image/*"
                capture="environment" class="d-none" multiple>
              <div *ngIf="pictures.length > 0" class="text-center mt-3">
                <div *ngFor="let picture of pictures; let i = index" style="position: relative; display: inline-block;">
                  <img [src]="picture.src" style="height: 7rem; border-radius: 5px;">
                  <button type="button" class="btn btn-primary"
                    style="border-radius: 50%; position: absolute; bottom: -10px; right: -10px;" (click)="pictureRemove(i)">
                    <fa-icon [icon]="fa.faTimes" style="color: #fff;"></fa-icon>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div *ngIf="!currentUser.mobile_phone" class="col-12">
                <h5 i18n>Mobile number</h5>
                <input class="form-control" formControlName="mobile_phone" type="tel">
                <span class="small text-muted" i18n>Provide your mobile phone so partner can contact you if it's
                  necessary.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-8 mt-0 mt-lg-3">
      <div>
        <div *ngFor="let checkoutShift of checkoutShifts.shifts" class="card mb-3">
          <div class="card-body p-3">
              <h5>
                {{ checkoutShift.start | date: 'EE' }} {{ checkoutShift.start | date: 'shortDate' }}
                {{ checkoutShift.start | date: 'H:mm - ' }} {{ checkoutShift.end | date: 'H:mm' }} ({{
                checkoutShift.duration }} <span i18n>h</span>)
              </h5>
              <table class="table table-dark mb-0">
                <thead>
                  <tr>
                    <th i18n>Item</th>
                    <th class="text-end" i18n>Price</th>
                    <th class="text-end" i18n>VAT</th>
                    <th class="text-end" i18n>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let invoicable of checkoutShift.invoicables">
                    <td>{{ invoicable | translateField: 'title' }}</td>
                    <td class="text-end">
                      {{ invoicable.amount | currency: organization.currency }} <span *ngIf="invoicable.number > 1"
                        class="text-nowrap">x {{ invoicable.number | number: '1.0-2' }}</span>
                    </td>
                    <td class="text-end">
                      {{ invoicable.total_tax | currency: organization.currency }}
                    </td>
                    <td class="text-end">
                      {{ invoicable.total | currency: organization.currency }}
                      <div *ngIf="invoicable.discount > 0" class="text-danger text-nowrap">{{ -invoicable.discount |
                        currency: organization.currency }}</div>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th colspan="3" i18n>Total</th>
                    <th class="text-end">{{ checkoutShift.total_invoicable | currency: organization.currency }}</th>
                  </tr>
                </tfoot>
              </table>
            
          </div>
        </div>
        <div class="card mb-3">
          <div class="card-body p-3">
            <div class="row g-3">
              <div *ngIf="checkoutShifts.shifts.length > 1" class="col-12 fw-bold">
                <span i18n>Grand total:</span>&nbsp;{{ checkoutShifts.total_invoicable | currency: organization.currency }}
              </div>

              <div *ngIf="discounts.length" class="col-12">
                <h5 i18n>Discount</h5>
                <select (change)="updateDiscount()" class="form-select" formControlName="discount_id">
                  <option [ngValue]="null" i18n>No discount</option>
                  <option *ngFor="let discount of discounts" [ngValue]="discount.id">{{ discount.type | i18nSelect:
                    discountTypes }} {{ discount.discount_percent | number: '1.0-2' }}%</option>
                </select>
              </div>

              <div *ngIf="checkoutShifts.shifts.length == 1" class="col-12">
                <h5 i18n>Repeat the same order</h5>
                <select (change)="updateRepeat()" formControlName="repeat" class="form-select">
                  <option value="" i18n>Just this once</option>
                  <option value="daily">
                    <ng-container i18n>Every day</ng-container>
                    <ng-container *ngIf="organization.discount_weekly">
                      &nbsp;(<ng-container i18n>discount</ng-container>
                      {{ organization.discount_weekly | number: '1.0-0' }}%)
                    </ng-container>
                  </option>
                  <option value="weekdays">
                    <ng-container i18n>Every weekday</ng-container>
                    <ng-container *ngIf="organization.discount_weekly">
                      &nbsp;(<ng-container i18n>discount</ng-container>
                      {{ organization.discount_weekly | number: '1.0-0' }}%)
                    </ng-container>
                  </option>
                  <option value="weekly">
                    <ng-container i18n>Every week</ng-container>
                    <ng-container *ngIf="organization.discount_weekly">
                      &nbsp;(<ng-container i18n>discount</ng-container>
                      {{ organization.discount_weekly | number: '1.0-0' }}%)
                    </ng-container>
                  </option>
                  <option value="biweekly">
                    <ng-container i18n>Every two weeks</ng-container>
                    <ng-container *ngIf="organization.discount_biweekly">
                      &nbsp;(<ng-container i18n>discount</ng-container>
                      {{ organization.discount_biweekly | number: '1.0-0' }}%)
                    </ng-container>
                  </option>
                  <option value="quadweekly">
                    <ng-container i18n>Every month</ng-container>
                    <ng-container *ngIf="organization.discount_quadweekly">
                      &nbsp;(<ng-container i18n>discount</ng-container>
                      {{ organization.discount_quadweekly | number: '1.0-0' }}%)
                    </ng-container>
                  </option>
                </select>
              </div>

              <div class="col-12">
                <h5 i18n>Payment method</h5>
                <select (change)="scrollToBottom()" class="form-select" formControlName="payment">
                  <ng-container *ngIf="!organization.disable_card_payments">
                    <option [ngValue]="'new_card'" i18n>New payment card</option>
                    <option *ngFor="let card of user.cards" [ngValue]="card.id">{{ card.number }} <ng-container
                        i18n>expires</ng-container> {{ card.expire_month | number: '2.0-0' }}/{{ card.expire_year }}
                    </option>
                  </ng-container>
                  <option *ngIf="customer.allow_ordering_with_invoice" ngValue="invoice" i18n>Invoice</option>
                  <option *ngIf="customer.allow_ordering_with_cash" ngValue="cash" i18n>Cash</option>
                </select>
                <span class="small text-muted" i18n>Your card will be pre-authorized 24h before and charged 12h after
                  service.</span>
                <div *ngIf="checkoutShifts.shifts.length > 0" class="col-12 mb-3 mt-4">
                  <input type="checkbox" id="tnc" class="form-check-input" formControlName="tnc">&nbsp;
                  <label class="form-check-label" for="tnc"><span i18n>I have read and accept</span>&nbsp;<a
                      href="javascript:void(0)" (click)="tnc()" i18n>terms and conditions</a></label>
                </div>

                <p *ngIf="checkoutShifts.shifts.length > 0 && Number(checkoutShifts.total_invoicable) < Number(minimumOrder)"
                  class="text-center">
                  <span i18n>You can't make this order. The minimum order amount is:&nbsp;</span>{{ minimumOrder |
                  currency: organization.currency
                  }}
                </p>

                <button *ngIf="checkoutShifts.shifts.length > 0" type="button" class="btn btn-primary w-100 ml-1 mr-1 mb-3"
                  [disabled]="checkoutShifts.total_invoicable < minimumOrder || checkoutShifts.shifts.length > 0 && Number(checkoutShifts.total_invoicable) < Number(minimumOrder) || sending"
                  (click)="order()">
                  <ng-container *ngIf="!sending" i18n>Send order</ng-container>
                  <ng-container *ngIf="sending">
                    &nbsp;<div class="spinner-border spinner-border-sm" role="status"></div>&nbsp;
                  </ng-container>
                </button>
                <button *ngIf="activeTab == 'checkout'" (click)="cancel()" type="button"
                  class="btn btn-danger w-100 ml-1 mr-1"><span i18n>Cancel order</span></button>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!checkoutShifts.shifts.length" class="text-center mt-5 mb-5">
          <div class="spinner-border spinner-border" role="status"></div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!checkoutShiftloaded" class="d-flex justify-content-center align-items-center mt-5 mb-5">
    <div class="spinner-border" role="status"></div>
  </div>
</form>
